import React from "react";

const Line = ({ prop }) => {
  return <div className={`bg-primary h-1 w-16 mt-5 ${prop}`}></div>;
};

export default Line;
